import store from "@/store";

export const mixinTravel = {
  computed: {
    isBeforeApplResultYn() { // 티켓 사용전, (사전검사)여행지원서만 작성한 결과가 있는지 값
      return store.getters.isBeforeApplResultYn;
    }
  },
  methods: {
    async getBeforeAppResultList () {
      // 가장 최근의 여행지원서 결과 (사전검사) 리스트 조회
      await store.dispatch('getApplResultList', {key: 'so', params: [{'travelApplNo': 1}, {'travelApplStepCd': '0001'}]})
         .then(res => {
           if (res.success) {
             if (res.data !== null) {
               if (res.data.filter(x => x.ordDtlNo  === null).length > 9){
                 store.commit('setBeforeApplResultYn', true)
               } else {
                 if (store.getters.useOrdDtl.travelYn === 'Y') {
                   store.commit('setBeforeApplResultYn', true)
                 } else {
                  store.commit('setBeforeApplResultYn', false)
                 }
               }
             }
           }
         })
    }
  }
}

